const Case = {
  Camel: 'camel',
};

const toCamelCase = (key) => {
  const keyWithSpecialCharsRemoved = key.replace(/([-_][a-z])/g, (group) =>
    group.toUpperCase().replace('-', '').replace('_', ''),
  );
  return (
    keyWithSpecialCharsRemoved.charAt(0).toLowerCase() +
    keyWithSpecialCharsRemoved.slice(1)
  );
};

const CASE_FORMATTER = {
  [Case.Camel]: toCamelCase,
};

const convertKeys = (valueToConvert, type = Case.Camel) => {
  const convertKey = CASE_FORMATTER[type];
  if (Array.isArray(valueToConvert)) {
    return valueToConvert.map((value) => convertKeys(value, type));
  }
  if (valueToConvert !== null && valueToConvert?.constructor === Object) {
    return Object.keys(valueToConvert).reduce(
      (result, key) => ({
        ...result,
        [convertKey(key)]: convertKeys(valueToConvert[key], type),
      }),
      {},
    );
  }
  return valueToConvert;
};

export default convertKeys;
